import { GET_LOCATION_LIST } from "./edit-hospital-location.query";
import { ILocationListResponse } from "./edit-hospital-location.interface";
import { useLazyQuery } from "@apollo/client";

export const useHospitalList = () => {
  const [getMetroLocations, { data, loading }] =
    useLazyQuery<{ getMetrolocations: ILocationListResponse }>(GET_LOCATION_LIST);

  return {
    getMetroLocations,
    metroLocations: data?.getMetrolocations.locations,
    currentLocation: data?.getMetrolocations.currentLocationId,
    loading,
  };
};

